var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsBadgeMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4248 0.5C11.8081 0.5 13.1085 0.762109 14.3252 1.28711C15.5418 1.8121 16.6 2.52485 17.5 3.4248C18.4 4.32476 19.1127 5.38302 19.6377 6.59961C20.1627 7.81628 20.4248 9.11667 20.4248 10.5C20.4248 11.8833 20.1627 13.1837 19.6377 14.4004C19.1127 15.617 18.4 16.6752 17.5 17.5752C16.6 18.4751 15.5418 19.1879 14.3252 19.7129C13.1085 20.2379 11.8081 20.5 10.4248 20.5C9.04147 20.5 7.74108 20.2379 6.52441 19.7129C5.30783 19.1879 4.24956 18.4751 3.34961 17.5752C2.44966 16.6752 1.73691 15.617 1.21191 14.4004C0.686914 13.1837 0.424805 11.8833 0.424805 10.5C0.424805 9.11667 0.686914 7.81628 1.21191 6.59961C1.73691 5.38302 2.44966 4.32476 3.34961 3.4248C4.24956 2.52485 5.30783 1.8121 6.52441 1.28711C7.74108 0.762109 9.04147 0.5 10.4248 0.5ZM10.4248 2.5C8.19147 2.5 6.3 3.2752 4.75 4.8252C3.2 6.3752 2.4248 8.26667 2.4248 10.5C2.4248 12.7333 3.2 14.6248 4.75 16.1748C6.3 17.7248 8.19147 18.5 10.4248 18.5C12.6581 18.5 14.5496 17.7248 16.0996 16.1748C17.6496 14.6248 18.4248 12.7333 18.4248 10.5C18.4248 8.26667 17.6496 6.3752 16.0996 4.8252C14.5496 3.2752 12.6581 2.5 10.4248 2.5ZM16.4248 11.5H4.4248V9.5H16.4248V11.5Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsBadgeMinus);
export default __webpack_public_path__ + "static/media/icons_badge_minus.c0e90c1f.svg";
export { ForwardRef as ReactComponent };